import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { signOut } from "../../redux/store/actions/authActions";

const SignedInLinks = props => {
  const userId = props.profile.firstName + props.profile.lastName;
  // console.log(userId);
  return (
    <Fragment>
      <ul className="right">
        <li>
          <NavLink to={"/"} title="Dashboard" className="">
            Español
          </NavLink>
        </li>
        <li>
          <NavLink to={"/usuario/" + userId} title="Mi Perfil" className="">
            Mi perfil
          </NavLink>
        </li>
        <li>
          <a href="/entrar" onClick={props.signOut} title="Cerrar Sesion">
            Salir
          </a>
        </li>
      </ul>
    </Fragment>
  );
};

const mapStateToProps = state => {
  // console.log(state)
  return {
    auth: state.firebase.auth,
    users: state.firestore.data.users
  };
};

const mapDispatchtoProps = dispatch => {
  return {
    signOut: () => dispatch(signOut())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchtoProps
)(SignedInLinks);
